<script>
  export default {
    name: 'content-element',
    props: {
      tagName: {
        required: true
      }
    },
    render (createElement) {
      return createElement(
       this.tagName, // tag name
       this.$slots.default // array of children
      )
    }
  }
</script>



// WEBPACK FOOTER //
// ContentElementComponent.vue?c642d334